import { useTranslation } from 'react-i18next';
import { card, cardBody, btnPrimary, REG_FONTS, flagBar } from './styles';

interface RegIntroProps {
  onStart: () => void;
}

export function RegIntro({ onStart }: RegIntroProps) {
  const { t } = useTranslation('regularizacion');

  return (
    <div className={card}>
      {flagBar}
      <div className={cardBody}>
        <h2
          className="text-xl font-bold text-[#1a1a1a] mb-3"
          style={{ fontFamily: REG_FONTS.heading }}
        >
          {t('intro.title')}
        </h2>
        <p className="text-[#444] mb-6 leading-relaxed" style={{ fontFamily: REG_FONTS.body }}>
          {t('intro.description')}
        </p>
        <button onClick={onStart} className={btnPrimary} style={{ fontFamily: REG_FONTS.body }}>
          {t('intro.cta')}
        </button>
      </div>
    </div>
  );
}
